import { cn } from '#app/utils/misc.tsx'
import { Icon } from '../ui/icon'

interface ARTBannerProps {
	variant?: 'expanded' | 'collapsed'
	onClose?: () => void
	className?: string
	position?: 'standalone' | 'modal-top'
}

export function ARTBanner({
	variant = 'expanded',
	onClose,
	className,
	position = 'standalone',
}: ARTBannerProps) {
	const isExpanded = variant === 'expanded'
	const isModalTop = position === 'modal-top'

	return (
		<div
			className={cn(
				'relative w-full overflow-hidden bg-gradient-to-l from-blue-500 to-teal-600',
				isExpanded ? 'h-[217px]' : 'h-20',
				isModalTop ? 'rounded-t-3xl' : 'rounded-3xl',
				className,
			)}
		>
			{/* Decorative lines */}
			<div className="pointer-events-none absolute -top-[969px] -left-[264px] h-[calc(1px*((1501.6875*0.7071067690849304)+(1431.59375*0.7071067690849304)))] w-[calc(1px*((1431.59375*0.7071067690849304)+(1501.6875*0.7071067690849304)))] opacity-10">
				<div className="h-full w-full -rotate-45 bg-[repeating-linear-gradient(0deg,transparent,transparent_20px,white_20px,white_21px)]" />
			</div>

			{/* Content */}
			<div
				className={cn(
					'relative flex h-full items-center justify-center gap-3 p-6',
				)}
			>
				{/* Icon + Title */}
				<div className="flex items-center gap-3">
					<div className="flex items-center justify-center rounded-xl bg-green-50 p-2">
						<Icon name="file-text" className="size-5 text-green-800" />
					</div>
					<p className="font-parkinsans text-lg leading-[30px] font-medium text-white">
						Seguro ART
					</p>
				</div>

				{/* Close button */}
				{onClose && (
					<button
						onClick={onClose}
						className="flex items-center justify-center transition-opacity hover:opacity-80"
						aria-label="Cerrar"
					>
						<Icon name="cross-1" className="size-5 text-white" />
					</button>
				)}
			</div>
		</div>
	)
}
